import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export default () => ({
  init() {
    this.initSplide();
    this.initCarSplide();
  },

  initSplide() {
    const splideElement = this.$el.querySelector('[data-block-slider]');
    if (!splideElement) {
      return;
    }

    new Splide(splideElement, {
      type: 'loop',
      focus: 'center',
      perPage: 3,
      perMove: 1,
      pagination: false,
      arrows: true,
      autoplay: false,
      interval: 3000,
      gap: '20px',
      breakpoints: {
        640: {
          perPage: 1,
          perMove: 1,
        },
      },
    }).mount();
  },

  initCarSplide() {
    const splideElement = this.$el.querySelector('[data-cars-slider]');
    if (!splideElement) {
      return;
    }

    const splide = new Splide(splideElement, {
      type: 'loop',
      focus: 'left',
      perPage: 4,
      perMove: 1,
      pagination: false,
      arrows: false,
      autoplay: false,
      interval: 3000,
      gap: '20px',
      breakpoints: {
        1800: {
          perPage: 3.2,
          perMove: 1,
          padding: 20,
        },
        1480: {
          perPage: 3,
          perMove: 1,
          padding: 20,
        },
        768: {
          perPage: 2,
          perMove: 1,
          padding: { right: '10%' },
        },
        640: {
          perPage: 1,
          perMove: 1,
          padding: { right: '20%' },
        },
      },
    });

    splide.mount();

    const prevBtn = this.$el.querySelector('[data-cars-prev]');
    const nextBtn = this.$el.querySelector('[data-cars-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
    if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));
  },
});
